<style scoped>
::v-deep .carousel-product-list-wrap {
    position: relative;
    @apply py-8;

    & .product-image-center {
        transform: scale(1.3);
        z-index: 2;
        transition: all 250ms ease-in;
    }

    & .product-image-side {
        transform: scale(1.2);
        z-index: 1;
        transition: all 250ms ease-in;
    }
}
</style>

<template>
    <div>
        <productCarousel
            :title="title"
            :list="_list"
            :productWidthClass="'w-1/5'"
            :getNumOfProductInCurrentScreenSize="() => 5"
            ref="productCarousel"
        >
            <template #product="{product, index, pos}">
                <button
                    @click="$emit('clickPrize', { prize: product })"
                    class="w-full focus:outline-none"
                    @transitionend="productCarouselTransitionend"
                >
                    <productImage
                        :product="product"
                        :index="index"
                        :pos="pos"
                        :imageType="'small'"
                        class="border border-gray-100 bg-white"
                        :class="{
                            'product-image-center': pos + 2 === index,
                            'product-image-side':
                                Math.abs(index - pos - 2) === 1
                        }"
                    />
                </button>
            </template>

            <template v-if="true" #leftButton="{pos}">
                <button
                    class="btn border-0 p-0 -ml-3 btn-disabled-reset carousel-product-list-btn"
                    :disabled="pos === -2 && false"
                    @click="prev"
                >
                    <div class="icon w-10 h-10 sm:w-12 sm:h-12">
                        <chevronLeft class="fill-current" />
                    </div>
                </button>
            </template>
            <template v-if="true" #rightButton="{pos}">
                <button
                    class="btn border-0 p-0 -mr-3 btn-disabled-reset carousel-product-list-btn"
                    :disabled="pos >= list.length - 3 && false"
                    @click="next"
                >
                    <div class="icon w-10 h-10 sm:w-12 sm:h-12">
                        <chevronRight class="fill-current" />
                    </div>
                </button>
            </template>
        </productCarousel>
    </div>
</template>

<script>
import productCarousel from './productCarousel.vue';
import productImage from './productImage.vue';
import chevronLeft from '../assets/svg/chevron_left.svg';
import chevronRight from '../assets/svg/chevron_right.svg';

export default {
    components: {
        productCarousel,
        productImage,
        chevronLeft,
        chevronRight
    },
    props: {
        title: { type: String },
        list: { type: Array, required: true },
        autoPlay: { type: Boolean, default: true }
    },
    data() {
        return {
            transitionend: true
        };
    },
    mounted() {
        const productCarousel = this.$refs.productCarousel;
        productCarousel.$data.pos = this._list_middle - 2;

        if (this.autoPlay) {
            this.scheuleNext();
        }
    },
    beforeDestroy() {
        if (this.autoPlayTimer) {
            clearTimeout(this.autoPlayTimer);
        }
    },
    computed: {
        _list() {
            let _list = [...this.list];
            while (_list.length > 0 && _list.length < 2 + 5 + 2) {
                _list = _list.concat(this.list).concat(this.list);
            }
            return _list;
        },
        _list_middle() {
            return Math.ceil(this._list.length / 2) - 1;
        },
        upperbound() {
            return this._list_middle + Math.floor(this.list.length / 2) - 2;
        },
        lowerbound() {
            const _singular = this.list.length % 2 === 1;
            const _minus = _singular
                ? Math.floor(this.list.length / 2)
                : Math.floor(this.list.length / 2) - 1;
            return this._list_middle - _minus - 2;
        }
    },
    methods: {
        prev() {
            if (this.autoPlayTimer) {
                clearTimeout(this.autoPlayTimer);
            }
            this.transitionend = false;
            const productCarousel = this.$refs.productCarousel;
            let prevNum = productCarousel.$data.pos - 1;
            if (prevNum < this.lowerbound) {
                productCarousel.$data.pos = this.upperbound;
            } else {
                productCarousel.$data.pos = prevNum;
            }
        },
        next() {
            if (this.autoPlayTimer) {
                clearTimeout(this.autoPlayTimer);
            }
            this.transitionend = false;
            const productCarousel = this.$refs.productCarousel;
            let nextNum = productCarousel.$data.pos + 1;
            if (nextNum > this.upperbound) {
                productCarousel.$data.pos = this.lowerbound;
            } else {
                productCarousel.$data.pos = nextNum;
            }
        },
        productCarouselTransitionend() {
            if (this.transitionend) {
                return;
            }

            this.transitionend = true;
            if (this.autoPlay) {
                this.scheuleNext();
            }
        },
        scheuleNext() {
            if (this.autoPlayTimer) {
                clearTimeout(this.autoPlayTimer);
            }
            this.autoPlayTimer = setTimeout(() => this.next(), 2000);
        }
    }
};
</script>
